// extracted by mini-css-extract-plugin
export default {"container":"chat-box_container__9awr4","listContainer":"chat-box_listContainer__0xunu","messageContainer":"chat-box_messageContainer__-rb3B","typing":"chat-box_typing__Td5d6"};